import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    ingresosEgresos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    ingresoEgresoTipo: null,
    personal: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.ingresosEgresos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.ingresoEgresoTipo = null;
        state.personal = null;
    },

    'INICIALIZAR_INGRESOS_EGRESOS' (state) {
        state.ingresosEgresos = [];
    },
    'SET_INGRESOS_EGRESOS' (state, ingresosEgresos) {
        state.ingresosEgresos = ingresosEgresos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getIngresosEgresos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INGRESOS_EGRESOS');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
            + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.ingresoEgresoTipo) {
                if (state.ingresoEgresoTipo.id != 0) {
                    queryString += '&ingresoEgresoTipoId=' + state.ingresoEgresoTipo.id;
                }
            }
            if (state.personal) {
                if (state.personal.id != 0) {
                    queryString += '&personalId=' + state.personal.id;
                }
            }
            
            apiAxios.get('ingresosegresos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }

                    commit('SET_INGRESOS_EGRESOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, ingresoEgresoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('ingresosegresos/' + ingresoEgresoId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}